import { InputDropdown, InputDropdownItem, InputText, InputCheckBox } from '@unbooking/ui-kit';
import { FC, useContext, useEffect } from 'react';
import { IRequestTrainingFormStepProps, RequestTrainingStep } from '../common/interfaces';
import BaseStep from './components/BaseStep';
import { RequestTrainingFormContext } from '../common/formContext';
import { nonEmptyValidation } from '../common/FieldValidationWarning';
import { RequiredUnderline } from '@/components/common';

const STEP = RequestTrainingStep.AGENCY;

export const AgencyStep: FC<IRequestTrainingFormStepProps> = ({
  formData,
  updateFormData,
  goToNextStep,
  goToPreviousStep,
  updateStepCompleted,
}) => {
  const { formContext } = useContext(RequestTrainingFormContext);
  const formStep = formData[STEP];

  const agencies = formStep?.agencies ?? [];
  const otherAgencies = formStep?.other_agencies ?? '';
  const isOtherAgencies = formStep?.is_other_agencies ?? '';

  const agencySelectedValidation = nonEmptyValidation(
    isOtherAgencies ? otherAgencies : agencies.length ? agencies : null,
  );

  const nextStepEnabled = agencySelectedValidation === null;

  const agencyOptions = formContext?.agencies ?? [];

  useEffect(() => {
    updateStepCompleted(STEP, nextStepEnabled);
  }, [nextStepEnabled]);

  const handleAgencyMissingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.value as unknown as string[];
    const isChecked = selected.includes('missing');

    if (isChecked) {
      updateFormData('agencies', []);
      updateFormData('is_other_agencies', isChecked);
    } else {
      updateFormData('is_other_agencies', false);
    }
  };

  return (
    <BaseStep
      goToNextStep={goToNextStep}
      formStep={STEP}
      goToPreviousStep={goToPreviousStep}
      nextStepEnabled={nextStepEnabled}
    >
      <div className="flex flex-col w-full gap-10">
        <div className="flex flex-col">
          <div className="flex flex-col items-stretch mb-7">
            <div className="text-white mb-2">
              Select the agency(s)/organization(s) for which you are requesting the training
            </div>
            <InputDropdown
              value={agencies}
              onChange={e => updateFormData('agencies', e.target.value)}
              items={agencyOptions as InputDropdownItem[]}
              name="agency-select"
              placeholder="Select one or more agencies"
              multiple
              isSearchable
              disabled={isOtherAgencies}
            />
            {agencySelectedValidation && !isOtherAgencies && <RequiredUnderline />}
          </div>
          <InputCheckBox
            direction="column"
            items={[{ label: 'My agency is not in the list', value: 'missing' }]}
            value={isOtherAgencies ? ['missing'] : []}
            onChange={e => handleAgencyMissingChange(e as React.ChangeEvent<HTMLInputElement>)}
            name="agency_checkbox"
          />

          <div className="text-white mb-2 mt-6">
            In case any of the agencies/organizations is missing from the list, please enter them
            below
          </div>
          <InputText
            value={otherAgencies}
            onChange={e => updateFormData('other_agencies', e.target.value)}
            name="other_agencies-input"
            placeholder="Enter missing agencies"
          />
          {agencySelectedValidation && isOtherAgencies && <RequiredUnderline />}
        </div>
      </div>
    </BaseStep>
  );
};

export default AgencyStep;
